module.exports = __webpack_public_path__ + "7af5176fa5bd6bbeab5e15d69f61952a.pdf";